import { Link } from '@design-system/Link';
import { NavBar } from '@design-system/NavBar';
import { UPDATE_MEDICAL_HISTORY_PATH } from '@/constants/paths';
import { MyHealthHistoryPageStatusSection } from './MyHealthHistoryPageStatusSection';

export const MyHealthHistoryPage = () => {
  return (
    <section className="page-container page-container flex flex-col gap-12">
      <div className="flex flex-col gap-6 md:gap-12">
        <NavBar
          buttonLabel={
            <span className="max-md:hidden">Settings & Information</span>
          }
        />

        <h1 className="typography-h1 text-primary">My Health History</h1>

        <MyHealthHistoryPageStatusSection />

        <p className="text-tertiary typography-body">
          It's important to keep Viome updated about any new health conditions
          so we can ensure your supplements are safe and right for you. Some
          ingredients can interact with medications or impact certain
          conditions, and we want to avoid any unintended effects. By sharing
          your latest health updates, we can fine-tune your recommendations to
          better support your well-being.
        </p>

        <div className="flex flex-col items-start text-tertiary typography-body">
          Have a change in your medical history?
          <Link
            variant="underline"
            className="text-tertiary"
            to={UPDATE_MEDICAL_HISTORY_PATH}
          >
            Let us know
          </Link>
        </div>
      </div>
    </section>
  );
};
